
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

/**
 * Component to handle authentication redirects and display appropriate messages
 */
const AuthRedirectHandler: React.FC = () => {
  const location = useLocation();
  const { toast } = useToast();
  
  // Check if we were redirected for password reset
  const isResettingPassword = new URLSearchParams(location.search).get('reset') === 'true';
  
  // Check if we have a hash in the URL (might be from an auth redirect)
  const hasAuthParams = location.hash.includes('access_token') || 
                         location.hash.includes('error_description') || 
                         location.hash.includes('type=recovery');

  useEffect(() => {
    if (isResettingPassword || hasAuthParams) {
      console.log("Processing auth redirect or password reset", { 
        isResettingPassword, 
        hash: location.hash 
      });
      
      // For password reset specific message
      if (isResettingPassword) {
        toast({
          title: "Password Reset",
          description: "You can now set a new password by following the link in your email.",
        });
      }
      
      // Handle auth redirects (including password reset confirmations)
      if (hasAuthParams) {
        const extractErrorMessage = () => {
          const params = new URLSearchParams(location.hash.substring(1));
          return params.get('error_description') || 'Authentication error occurred';
        };
        
        if (location.hash.includes('error_description')) {
          toast({
            title: "Authentication Error",
            description: decodeURIComponent(extractErrorMessage()),
            variant: "destructive"
          });
        }
      }
    }
  }, [isResettingPassword, hasAuthParams, location.hash, toast]);

  return null;
};

export default AuthRedirectHandler;
